import React from 'react'
import Paper from '@material-ui/core/Paper'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'

const styles = theme => ({
  containerPaper: {
    background: theme.palette.common.white,
    padding: '0px 16px 0px 16px',
    marginLeft: '16px',
    minHeight: '232px',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flex: 1
  },
  flexColumn: {
    flex: 1,
    paddingLeft: '8px',
  },
  gridContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  productImage: {
    alignSelf: 'center',
    width: '240px'
  },
  productContent: {
    marginLeft: '18px'
  },
  earningsCalculatorProductsTitle: {
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '0.875rem;',
    letterSpacing: '0.22px',
    lineHeight: 1.5,
    marginBottom: 0,
    marginTop: 0
  },
  earningsCalculatorProductsDescription: {
    marginTop: 0,
    marginBottom: '16px',
    textAlign: 'left',
    fontSize: '0.875rem;',
    lineHeight: 1.5
  },
  noSpacing: {
    marginBottom: 0
  }
})

const renderPoduct = (product, classes) => {
  const {
    excerpt,
    frontmatter: { title, order, price },
    id
  } = product.node

  return (
    <div key={id}>
      <p className={classes.earningsCalculatorProductsTitle}>
        {order}. {title}
        {price && `: ${price}`}
      </p>
      <p className={classes.earningsCalculatorProductsDescription}>
        {excerpt}
      </p>
    </div>
  )
}

const EarningsCalculatorCardDesktop = ({
  classes,
  products,
  catalog,
  tabActive,
  productsImage,
}) => {
  return (
    <Paper className={classes.containerPaper}>
      <Grid
        alignContent="center"
        container
        className={`${classes.flexColumn} ${classes.gridContainer}`}
      >
        <Grid className={classes.productImage} item>
          {productsImage}
        </Grid>
        <Grid item className={classes.flexColumn}>
          { !catalog ?
            (
              products.map(product => renderPoduct(product, classes))
            ) :
            (<>
              { tabActive === 1 ? (
                products.map(product => renderPoduct(product, classes))
              ) : (
                catalog.map(product => {
                  const {
                    excerpt,
                    frontmatter: { title, order, price },
                    id
                  } = product.node

                  return (
                    <div key={id}>
                      <p className={classes.earningsCalculatorProductsTitle}>
                        {order}. {title}
                        {price && `: ${price}`}
                      </p>
                      <p className={classes.earningsCalculatorProductsDescription}>
                        {excerpt}
                      </p>
                    </div>
                  )
                })
              )}
            </>
            )
          }
        </Grid>
      </Grid>
    </Paper>
  )
}

export default withStyles(styles)(EarningsCalculatorCardDesktop)
